<template>
  <b-button id="GoBackBtn" @click="handleClick" class="brand-highlight-3 bg-white p-0 go-back-btn d-flex justify-content-center align-items-center">
    <i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>
    <span>Go back</span>
  </b-button>
</template>

<script>

export default {
  name: "GoBackBtn",
  methods: {
    handleClick() {
      this.$router.go(-1);
    },
  },
}
</script>

<style lang="less">
#GoBackBtn.go-back-btn {
  font-size: 1.8rem !important;
  line-height: 1.8rem;
  letter-spacing: 0 !important;
  border-bottom: 2px solid transparent !important;
  border-radius: unset !important;
  padding-bottom: 4px !important;
  font-family: "PlusJakartaSansBold";

  &:hover, &:focus {
    color: #009577 !important;
    border-bottom: 2px solid #009577 !important;
  }
}
</style>